const OptionCard = ({ label, selected, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`
        w-full p-5 text-left text-[15px] font-medium
        rounded-[14px]
        transition-all duration-200
        border
        flex items-center justify-between
        ${
          selected
            ? 'bg-[hsl(var(--brand-black))] text-white border-[hsl(var(--brand-black))] transform -translate-y-0.5 shadow-[0_8px_20px_rgba(0,0,0,0.3)]'
            : 'bg-[hsl(var(--bg-card))] border-[hsl(var(--border-light))] text-[hsl(var(--text-primary))] hover:border-[hsl(var(--accent-primary))] hover:-translate-y-0.5 hover:shadow-[0_12px_24px_-6px_rgba(0,0,0,0.12)]'
        }
      `}
      style={{
        transitionTimingFunction: 'cubic-bezier(0.2, 0.8, 0.2, 1)'
      }}
    >
      <span className="leading-snug">{label}</span>
      {selected && (
        <svg
          className="w-5 h-5 flex-shrink-0 ml-2"
          style={{
            animation: 'checkScale 0.2s cubic-bezier(0.2, 0.8, 0.2, 1)'
          }}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M5 13l4 4L19 7"
          />
        </svg>
      )}
    </button>
  );
};

export default OptionCard;
